import { CalendarRange, Package, Pause, Pencil, Percent, Play, Ticket } from 'lucide-react';
import { eventWindow, formatEventRange, pricingLabel } from './eventWindow';
import styles from './Events.module.css';

const WINDOW_CLASS = {
  live: 'windowLive',
  scheduled: 'windowScheduled',
  ended: 'windowEnded',
  inactive: 'windowInactive',
};

const WINDOW_LABEL = {
  live: 'Live now',
  scheduled: 'Scheduled',
  ended: 'Ended',
  inactive: 'Inactive',
};

function PricingIcon({ mode }) {
  if (mode === 'PERCENT') return <Percent size={11} />;
  if (mode === 'COUPON') return <Ticket size={11} />;
  return <Package size={11} />;
}

export default function EventCard({ event, onEdit, onToggle, toggling, editing }) {
  const window = eventWindow(event);

  return (
    <div className={styles.card}>
      <div className={styles.banner}>
        {event.imageUrl ? (
          <img src={event.imageUrl} alt="" className={styles.bannerImg} />
        ) : (
          <div className={styles.bannerFallback}>
            <span>{event.name}</span>
          </div>
        )}
        <span className={`${styles.windowChip} ${styles[WINDOW_CLASS[window]]}`}>{WINDOW_LABEL[window]}</span>
        <span className={`${styles.statusChip} ${event.status === 'ACTIVE' ? styles.statusActive : styles.statusInactive}`}>
          {event.status}
        </span>
      </div>

      <div className={styles.body}>
        <p className={styles.name}>{event.name}</p>
        {event.description && <p className={styles.description}>{event.description}</p>}

        <div className={styles.metaRow}>
          <span className={styles.meta}>
            <CalendarRange size={12} /> {formatEventRange(event)}
          </span>
          <span className={styles.meta}>
            <Package size={12} /> {event.itemIds?.length || 0} product{(event.itemIds?.length || 0) === 1 ? '' : 's'}
          </span>
        </div>

        <span className={styles.pricingBadge}>
          <PricingIcon mode={event.pricingMode} />
          {pricingLabel(event)}
        </span>

        <div className={styles.actions}>
          <button type="button" className={styles.cardBtn} onClick={() => onEdit(event)} disabled={editing}>
            <Pencil size={13} /> {editing ? 'Loading…' : 'Edit'}
          </button>
          <button type="button" className={styles.cardBtn} onClick={() => onToggle(event)} disabled={toggling}>
            {toggling
              ? '…'
              : event.status === 'ACTIVE'
                ? <><Pause size={13} /> Pause</>
                : <><Play size={13} /> Activate</>}
          </button>
        </div>
      </div>
    </div>
  );
}
